Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Twitch", {
  enumerable: true,
  get: function get() {
    return _twitch.Twitch;
  }
});
var _twitch = require("./twitch");